import * as fromDatatype from '../datatype-library/index';

export interface bl_pos_customer_view_attachment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_file: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
  sort_code : fromDatatype.VarcharDatatypeInterface;
}

export class bl_pos_customer_view_attachment_RowClass implements bl_pos_customer_view_attachment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_file: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
  sort_code : fromDatatype.VarcharDatatypeInterface;
}
